import { Flex, Layout } from "antd";
import dayjs from "dayjs";

import { name } from "../../providers/companyInfo";

const packageJson = require("../../../../package.json");

export default function Footer() {
	return (
		<Layout.Footer>
			<Flex justify="space-between">
				<span>
					TM and © {dayjs().format("YYYY")} {`${name}. All Rights Reserved.`}
				</span>

				<span>
					V:{" "}
					{packageJson && packageJson.version ? packageJson.version : "0.0.1"}
				</span>
			</Flex>
		</Layout.Footer>
	);
}
